module.exports = __webpack_public_path__ + "img/icon_img05.cad6a11a.png";